import React from "react"
import ContextConsumer from "../context"
import TransitionLink from "gatsby-plugin-transition-link"
import { exitFunction, entryFunction, exitMobileFunction, entryMobileFunction } from "../navAnimationFunctions"
import Img from "gatsby-image/withIEPolyfill"
import BackgroundImage from "gatsby-background-image"
import { FiArrowRight } from "react-icons/fi"
import StripesRight from "../../images/stripes-left-4.png";

const NavCard = ({
  name,
  name2,
  link,
  number,
  clickHandler,
  slideIndex,
  heroImageFluid,
  toggleView,
  appWidth,
  appHeight,
  color,
}) => {
  let mobileChecker = appWidth < 642 || (appHeight < 600 && appWidth < 642) || ((appHeight / appWidth < .7) && appHeight < 600);
  // console.log(mobileChecker);

  const nameSlug = name.toLowerCase().replace(" ", "-")
  let nameTop = (!mobileChecker ? name.split(" ")[0] : name2.split(" ")[0]);
  let nameBottom = (!mobileChecker ? name.split(" ")[1] : name2.split(" "));
  let nameTop2 = null;
  if(mobileChecker && nameBottom.length > 2) {
    nameTop2 = name2.split(" ")[1];
    nameBottom = name2.split(" ")[2];
  } else if(mobileChecker) {
    nameBottom = name2.split(" ")[1];
  }
  if(!mobileChecker && nameTop === "CEO") {
      nameTop = "Interim " + nameTop;
  }
  if(mobileChecker && nameTop.indexOf("Core") !== -1) {
      nameTop2 = nameTop2 + " &";
      nameBottom = "EXECUTIVE TEAM";
  }
  // console.log(nameTop);
  const color1 = color.split("|")[0];
  const color2 = color.split("|")[1];
  const color3 = color.split("|")[2];

  return (
    <ContextConsumer>
      {({ contextData, set }) => {
        return (
          <div
            className={[
              contextData.slideIndex === number - 1
                ? "active slider-nav-card"
                : "slider-nav-card",
            ]}
          >
            <TransitionLink
              style={{backgroundImage: 'url(' + StripesRight + ')', backgroundSize: '160% 100%'}}
              data-id={number}
              onClick={ 
                  () => {
                    set({ slideIndex: number - 1, path: `/${nameSlug}`});
                  }
              }
              to={`/${nameSlug}`}
              exit={!mobileChecker ? {
                trigger: ({ node, e }) => exitFunction(node, e),
                length: 0.75,
              } : {
                trigger: ({ node, e }) => exitMobileFunction(node, e),
                length: 0.6,
              }}
              entry={!mobileChecker ? {
                trigger: ({ node, e }) => entryFunction(node, e),
                delay: 0.25,
                appearAfter: 0.01,
              } : {
                trigger: ({ node , e }) => { toggleView(); entryMobileFunction(node, e); },
                delay: .6,
              }}
            >
              <div className="bg-card" style={{backgroundImage: 'url(' + heroImageFluid.src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', height: '100%'}}>
                <h3>{number}</h3>
                <p><span className={color1}>{nameTop}</span>&nbsp;<span className={color2}>{nameTop2}</span><span className={color3 ? color3 : (color2 && color2)}>{nameBottom && nameBottom}</span></p>
              </div>
              <div className="nextArrow">
                <FiArrowRight />
              </div>
            </TransitionLink>
          </div>
        )
      }}
    </ContextConsumer>
  )
}

export default NavCard
